// src/theme/index.js
import { createTheme } from '@mui/material/styles';

const baseTheme = {
  typography: {
    fontFamily: 'DM Sans ,sans-serif !important',
    h1: {
      fontWeight: 500,
      fontSize: '2.5rem',
    },
    button: {
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          padding: '8px 16px',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: 'none', // Removes default gradient
        },
      },
    },
  },
};

const lightTheme = createTheme({
  ...baseTheme,
 palette: {
      mode: "light",
      primary: {
        main: '#A7C5EBFF',
      },
      background: {
        default: "#F0F3FE",
      },
       text: {
      primary: 'rgba(0, 0, 0, 0.87)',  // Almost black
      secondary: 'rgba(0, 0, 0, 0.6)',  // Dark gray
    },
    },
});

const darkTheme = createTheme({
  ...baseTheme,
  palette: {
    mode: 'dark',
     primary: {
        main: '#3f4044',
      },
   background:
   {
   default:'#3f4044 !important'},
    text: {
      primary: '#ffffff',      // White
      secondary: 'rgba(255, 255, 255, 0.7)',  // Light gray
    },
  },
});

export { lightTheme, darkTheme };